import { AbDatePipe } from '../pipes/ab-date.pipe';
import { Inject, LOCALE_ID, PLATFORM_ID, Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Moment } from 'moment';

@Injectable()
export class AbDateAdapter extends MomentDateAdapter {
  constructor(
    private abDatePipe: AbDatePipe,
    @Inject(LOCALE_ID) locale: string,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(locale, platformId);
  }

  format(value: Moment) {
    return this.abDatePipe.transform(value);
  }
}
